export const AI_EDIT_POLL_INTERVAL_MS = 1500;
export const AI_EDIT_DISCARD_MESSAGE = 'The local document edit will be discarded.';
export const AI_EDIT_SELECTION_NOT_RESTORED_MESSAGE =
  'The document changed, so your selection could not be highlighted again. The edit still uses what you selected.';
export const AI_EDIT_SUPPORT_NOTE = 'The problem was reported to your support team.';
export const AI_EDIT_DECISIONS_FAILED_MESSAGE = `The edit decision could not be saved. ${AI_EDIT_SUPPORT_NOTE}`;
export const AI_EDIT_DECISIONS_CONNECTION_LOST_MESSAGE = 'Connection lost while saving the edit decision.';
